module.exports = __webpack_public_path__ + "img/Event-Icon-Primary.77654f31.svg";